import { render, staticRenderFns } from "./middle_page.vue?vue&type=template&id=015a2c84&"
import script from "./middle_page.vue?vue&type=script&lang=js&"
export * from "./middle_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports